import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { getWorkScheduleList } from '../../helpers/';
import { workScheduleApiResponseSuccess, workScheduleApiResponseError } from "./actions";
import { WorkScheduleActionTypes } from "./constants";

/**
 * 
 * Get Work Schedule
 * @param {*} payload
 * @query - page
 * 
 */

function* workScheduleList({ payload }) {
  try{
    const response = yield call(getWorkScheduleList, payload.params);
    console.log('SAGA: ', response)
    yield put(workScheduleApiResponseSuccess(WorkScheduleActionTypes.GET_WORK_SCHEDULE_LIST, response.data));
  } catch(error) {
    console.log('ERROR: ', error);
    yield put(workScheduleApiResponseError(WorkScheduleActionTypes.GET_WORK_SCHEDULE_LIST, error));
  }
};

export function* watchWorkScheduleList() {
  yield takeEvery(WorkScheduleActionTypes.GET_WORK_SCHEDULE_LIST, workScheduleList);
}

function* workScheduleSaga() {
  yield all([
    fork(watchWorkScheduleList),
  ])
};

export default workScheduleSaga;